// utils/cleanAndFillAbc.js
import { normalizeKey, normalizeType } from './normalize'; // at top if not already


export function cleanAndFillAbc({ rawAbc, type = '', key = '' }) {
  const lines = rawAbc.split('\n').map(line => line.trim());

  const resultLines = [];
  let hasK = false;
  let hasM = false;
  let hasL = false;

  for (let line of lines) {
    if (!line) continue;

    // Remove X field
    if (/^X:\s*/i.test(line)) continue;

    // Remove empty headers (like "Z:" or "Q:")
    if (/^[A-Z]:\s*$/i.test(line)) continue;

    // Track what exists
    if (/^K:\s*\S+/i.test(line)) hasK = true;
    if (/^M:\s*\S+/i.test(line)) hasM = true;
    if (/^L:\s*\S+/i.test(line)) hasL = true;

    resultLines.push(line);
  }

  // Insert M:, L:, K: if missing
  const inserts = [];

  const meter = guessMeter(type);
  const needsMeter = !hasM && meter;
  const needsKey = !hasK && key;
  const needsLength = !hasL && meter && ['2/4', '3/4', '4/4', '6/8', '9/8', '12/8'].includes(meter);

  if (needsMeter) inserts.push(`M:${meter}`);
  if (needsLength) inserts.push(`L:1/8`);
if (needsKey) inserts.push(`K:${normalizeKey(key)}`);

// Normalize existing R: line (if present)
const rIndex = resultLines.findIndex(l => /^R:/i.test(l));
if (rIndex !== -1) {
  resultLines[rIndex] = `R:${normalizeType(type)}`;
}

// Normalize existing K: line (if present)
const kIndex = resultLines.findIndex(l => /^K:/i.test(l));
if (kIndex !== -1) {
  resultLines[kIndex] = `K:${normalizeKey(key)}`;
}


  // Insert after R: if found, or at top
  const insertIndex = resultLines.findIndex(l => /^R:/i.test(l)) + 1 || 1;
  resultLines.splice(insertIndex, 0, ...inserts);

  return resultLines.join('\n');
}

function guessMeter(type = '') {
  const t = type.toLowerCase();
  if (t.includes('slip jig') || t.includes('hop jig')) return '9/8';
  if (t.includes('jig')) return '6/8';
  if (t.includes('slide')) return '12/8';
  if (t.includes('reel') || t.includes('hornpipe')) return '4/4';
  if (t.includes('waltz') || t.includes('mazurka')) return '3/4';
  if (t.includes('polka')) return '2/4';
  if (t.includes('barndance') || t.includes('march')) return '4/4';
  return '';
}
